import { ArtistDetailType, ArtWorkType, CommonListResponse, ConcernsArtistParams, RecommendType } from 'common/types';
import { FastApiAxiosInstance } from 'common/service/axiosInstances';
import { IPagination } from 'common/types/api';

const artistV2 = {
  //普通分页获取创作者列表
  getArtistListByPage: async (params: {
    requirementTypeId?: number;
    styles?: number[];
    _page: number;
    _num: number;
    _nextId?: number;
    _query?: string;
    endTime?: string;
    startTime?: string;
    relationGame?: number;
  }) => {
    return FastApiAxiosInstance.post<{
      total: number;
      items: ArtistDetailType[];
    }>('/api/v2/artist/artistListByPage', params);
  },
  // 前台根据父任务id获取推荐创作者列表
  getRecommentArtistList: async (params: { parentTaskId: number; topUserIds?: number[]; lastUserCode?: string }) => {
    return FastApiAxiosInstance.post<{ items: ArtistDetailType[]; total: number }>(
      '/api/v2/artist/getRecommendArtists',
      params,
    );
  },
  // 后台根据父任务id获取推荐创作者列表
  getRecommentArtistListBackend: async (params: {
    parentTaskId: number;
    topUserIds?: number[];
    lastUserCode?: string;
  }) => {
    return FastApiAxiosInstance.post<{ items: ArtistDetailType[]; total: number }>(
      '/api/v1/backend/getRecommendArtists',
      params,
    );
  },
  //获取创作者作品列表
  getUserArtworkList: (params: { userId: number }) => {
    return FastApiAxiosInstance.get<{ total: number; items: ArtWorkType[] }>('/api/v2/artist/getUserArtworkList', {
      params,
    });
  },

  // ----------------------------------------
  // 我的创作者相关接口服务 v0.7.1.3
  // ----------------------------------------

  // 查询关注者列表 /api/v2/artist/ConcernsArtistByPage
  getConcernsArtistByPage: (params: ConcernsArtistParams) => {
    return FastApiAxiosInstance.post<
      CommonListResponse<ArtistDetailType> & {
        expireTime: string;
        unConcernNum: number; // 未关注数量
        fromUser: { uniqueId: number; nickName: string };
      }
    >('/api/v2/artist/ConcernsArtistByPage', params);
  },

  // 获取分享ID /api/v2/artist/getShareId
  // 通过分享ID，再次请求关注者列表，会包含指定的 shareId，以及过期时间，此时可进行一键关注或者单个关注
  getConcernsShareId: () => {
    return FastApiAxiosInstance.get<{ shareId: 'string'; expireTime: 'string' }>('/api/v2/artist/getShareId');
  },

  // 关注创作者、关注分享列表 /api/v2/artist/concernArtist
  concernsArtist: (params: { userId: number } | { shareId: string }) => {
    return FastApiAxiosInstance.post<{ total: number; items: ArtistDetailType[] }>(
      '/api/v2/artist/concernArtist',
      params,
    );
  },

  // 取消关注创作者 /api/v2/artist/unconcernArtist
  unconcernArtist: (params: { userId: number }) => {
    return FastApiAxiosInstance.post('/api/v2/artist/unconcernArtist', params);
  },

  // 历史合作创作者列表 /api/v2/artist/getCooperateHistory
  getCooperateHistory: (params: IPagination) => {
    return FastApiAxiosInstance.get<CommonListResponse<ArtistDetailType>>('/api/v2/artist/getCooperateHistory', {
      params,
    });
  },
};

export default artistV2;
